import { Input, InputProps } from '@Pages/pageRuntime/components/ui/form/Input';
import { ReactNode, Ref } from 'react';

import { FormField, FormFieldPropsWithoutChildren } from './FormField';
import { TextInputProps } from './TextInput';

export type FormTextInputProps = FormFieldPropsWithoutChildren &
  TextInputProps & {
    renderInput?: (props: InputProps) => ReactNode;
    'data-block-id'?: string;
    'data-block-type'?: string;
  };

export const FormTextInput = ({
  label,
  helpText,
  error,
  isRequired,
  id,
  labelActions,
  inputActions,
  value,
  onChange,
  type = 'text',
  disabled,
  className,
  'data-block-id': dataBlockId,
  'data-block-type': dataBlockType,
  ref,
  renderInput,
  ...inputProps
}: FormTextInputProps & { ref?: Ref<HTMLInputElement> }) => {
  return (
    <FormField
      label={label}
      helpText={helpText}
      error={error}
      isRequired={isRequired}
      id={id}
      labelActions={labelActions}
      inputActions={inputActions}
      classes={className}
      data-block-id={dataBlockId}
      data-block-type={dataBlockType}
    >
      {renderInput ? (
        renderInput({ type, disabled, value: value ?? '', onChange, ...inputProps })
      ) : (
        <Input
          ref={ref}
          type={type}
          disabled={disabled}
          value={value ?? ''}
          onChange={onChange}
          {...inputProps}
        />
      )}
    </FormField>
  );
};
FormTextInput.displayName = 'FormTextInput';
